interface AuthorityBadgeIconProps {
  width?: number
  height?: number
}

export default function AuthorityBadgeIcon({
  width = 16,
  height = 16,
}: Readonly<AuthorityBadgeIconProps>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={width}
      height={height}
      aria-hidden="true"
      focusable="false"
    >
      <g stroke="black" strokeWidth="5" strokeLinecap="round">
        <line x1="12" y1="34" x2="26" y2="34" />
        <line x1="18" y1="44" x2="32" y2="44" />
        <line x1="14" y1="54" x2="24" y2="54" />
      </g>

      <g
        stroke="black"
        strokeWidth="9"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      >
        <path d="M 58 38 L 44 44" />
        <path d="M 48 56 L 22 82" />
        <path d="M 62 36 L 48 56" />
        <path d="M 62 36 L 76 46 L 84 40" />
        <path d="M 48 56 L 66 60 L 72 78" />
      </g>

      <circle cx="74" cy="20" r="7.5" fill="black" />
    </svg>
  )
}
